import { Button } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons/faTrashCan';
import { color } from '@ifixit/primitives';

const TrashButton = ({
   onClick,
   isDisabled = false,
}: {
   onClick: () => void;
   isDisabled?: boolean;
}) => (
   <Button _hover={{ background: color.red[300] }} onClick={onClick} isDisabled={isDisabled}>
      <FontAwesomeIcon icon={faTrashCan} />
   </Button>
);

export default TrashButton;
